export default {
	styleOverrides: {
		root: {
            padding:"0 18px",
			'& .MuiTypography-body1': {
				fontSize: '13px',
				fontWeight: 600,
			},
		},
	},
}
